import React, { Fragment } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';

import { Button, Table } from 'react-bulma-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LevelIndicator } from '../components';
import { Link } from "@reach/router"
import { Loader } from '../components';
import PageTitle from '../components/pagetitle';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

export const GET_MY_BOOKMARKS = gql`
  query GetMyBookmarks {
    myBookmarks {
      slug
      type
      title
      level
    }
  }
`;

const REMOVE_BOOKMARK = gql`
  mutation RemoveBookmarkFromLibrary($songSlug: String!) {
    removeBookmark(songSlug: $songSlug) {
      slug
      isBookmarked
    }
  }
`;

const BookmarksTable = ({ heading, items, emptyMessage, onRemove }) => (
  <Fragment>
    <Table striped={true} size="fullwidth">
      <thead>
        <tr><th>{heading}</th><th style={{width: "120px"}}>Difficulty</th><th style={{width: "60px"}}></th></tr>
      </thead>
      <tbody>
        { items.length === 0 ? (
          <tr><td colSpan="3">{emptyMessage}</td></tr>
        ) : (
          items.map(item => (
            <tr key={item.slug}>
              <td><Link to={`/${item.type === 'fact' ? 'fact' : 'song'}/${item.slug}`}>{item.title}</Link></td>
              <td><LevelIndicator level={item.level} max={5} color="green"/></td>
              <td>
                <Button
                  size="small"
                  title="Remove bookmark"
                  onClick={() => onRemove(item.slug)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  </Fragment>
);

const MyLibrary = () => {
  const { data, loading, error } = useQuery(GET_MY_BOOKMARKS, {
    fetchPolicy: "no-cache",
  });
  const [removeBookmark] = useMutation(REMOVE_BOOKMARK, {
    refetchQueries: ['GetMyBookmarks'],
  });

  if (error) return <p>ERROR</p>;

  const handleRemove = (slug) => removeBookmark({ variables: { songSlug: slug } });
  const facts = data?.myBookmarks.filter(item => item.type === 'fact') ?? [];
  const songs = data?.myBookmarks.filter(item => item.type !== 'fact') ?? [];

  return(
    <Fragment>
      <PageTitle name="My library" description="Songs and facts you've bookmarked" />

      { loading ? <Loader /> : (
        <Fragment>
          <BookmarksTable
            heading="Facts"
            items={facts}
            emptyMessage="You haven't bookmarked any facts yet."
            onRemove={handleRemove}
          />
          <BookmarksTable
            heading="Songs"
            items={songs}
            emptyMessage="You haven't bookmarked any songs yet."
            onRemove={handleRemove}
          />
        </Fragment>
      )}
    </Fragment>
  )
}

export default MyLibrary;
